import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import ReactDOM from "react-dom";
import numWords from "num-words";
import "./ManageCreditNote.css";
import { CSVLink } from "react-csv";
import image2 from "../../uploads/pinnacle_logo.png";
import {
  PDFDownloadLink,
  Page,
  Text,
  Document,
  PDFViewer,
  StyleSheet,
  View,
  Image,
} from "@react-pdf/renderer";

function ManageCreditNote() {
  const [data2, setData2] = useState([]);
  const [listO, setlistO] = useState([]);
  const [selectedPDF] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [selectedDistributor, setSelectedDistributor] = useState("All");
  const [distributorOptions, setDistributorOptions] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const csvHeaders = [
    { label: "Distributor", key: "Distributor" },
    { label: "OrderSeq", key: "OrderSeq" },
    { label: "Date", key: "Date" },
    { label: "Total Quantity", key: "totalquantity" },
    { label: "Total Amount Value", key: "totalAmountValue" },
    { label: "SKU", key: "SKU" },
    { label: "Title", key: "Title" },
    { label: "Edition", key: "Edition" },
    { label: "Medium", key: "Medium" },
    { label: "MRP", key: "mrp" },
    { label: "Discount (%)", key: "discount" },
    { label: "Return Quantity", key: "Return_Quantity" },
  ];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const filteredByDate = data2.filter((item) => {
    if (!startDate && !endDate) return true;
    const itemDate = new Date(item.Date);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    if (start && itemDate < start) return false;
    if (end && itemDate > end) return false;
    return true;
  });
  const filteredData =
    selectedDistributor === "All"
      ? filteredByDate
      : filteredByDate.filter(
          (item) => item.Distributor === selectedDistributor
        );

  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManagereturn`).then(
      (response) => {
        const reversedData = response.data.reverse();
        setData2(reversedData);

        const distributors = [
          "All",
          ...new Set(reversedData.map((item) => item.Distributor)),
        ];
        setDistributorOptions(distributors);
      }
    );

    Axios.get(
      `${INVENTORY_API_BASE_URL}/getCreatesuperdistributor`
    ).then((response) => {
      setlistO(response.data);
    });
  }, []);

  const csvData = filteredData.flatMap((item) =>
    item.Entries.map((entry) => ({
      Distributor: item.Distributor,
      OrderSeq: item.OrderSeq,
      Date: item.Date,
      totalquantity: item.totalquantity,
      totalAmountValue: item.totalAmountValue,
      SKU: entry.SKU || "",
      Title: entry.Title || "",
      Edition: entry.Edition || "",
      Medium: entry.Medium || "",
      mrp: entry.mrp || "",
      discount: entry.discount || "",
      Return_Quantity: entry.Return_Quantity || "",
    }))
  );

  const generatePDF = (selectedObject) => {
    let total = 0;
    let sum = 0;
    const itemsPerPage = 9;
    const filteredData = data2.filter(
      (item) => item.OrderSeq === selectedObject.OrderSeq
    );

    const matchingObject = listO.find(
      (obj) => obj.dname === selectedObject.Distributor
    );

    filteredData.forEach((item) => {
      item.Entries.forEach((row) => {
        total += parseFloat(
          row.Return_Quantity * (row.mrp - (row.mrp * row.discount) / 100)
        );
        sum += parseFloat(row.Return_Quantity);
      });
    });
    const tota = Math.round(total);
    const totalInWords = numWords(tota);


    const styles = StyleSheet.create({
      page: {
        flexDirection: "column",
        padding: "1rem",
        border: "5rem",
      },
      section: {
        display: "flex",
        flexDirection: "row",
        marginLeft: 4,
        marginRight: 4,
      },
      title: {
        fontSize: 12,
      },
      listItem: {
        marginBottom: "0.5rem",
      },
      box: {
        border: "1px solid black",
      },
      stationView: {
        border: "1px solid black",
        padding: 5,
      },
      pdfhead: {
        textAlign: "center",
        marginTop: 5,
        marginBottom: 8,
      },
      pdfhead2: {
        textAlign: "center",
        fontSize: 12,
      },
      pdfdetails: {
        fontSize: 14,
        marginLeft: 5,
      },
      pdfaddress: {
        fontSize: 12,
      },
      column: {
        flex: 1, 
        border: "1px solid black",
      },
      main: {
        marginBottom: 8,
        marginTop: 5,
        marginLeft: 5,
      },
      main2: {
        marginTop: 20,
      },
      details: {
        marginBottom: 5,
      },
      second: {
        fontSize: 12,
      },
      second2: {
        fontSize: 12,
        marginLeft: 15,
      },
      address: {
        marginLeft: 5,
      },
      secondrow: {
        border: "1px solid black",
        marginLeft: 4,
        marginRight: 4,
        marginTop: 8,
      },
      thirdrow: {
        border: "1px solid black",
        marginLeft: 4,
        marginRight: 4,
        marginTop: 8,
      },
      forthrow: {
        border: "1px solid black",
        marginLeft: 4,
        marginRight: 4,
        marginTop: 8,
      },
      thirdrowquantity: {
        marginLeft: 220,
        fontSize: 13,
      },
      gst: {
        marginLeft: 380,
        fontSize: 13,
        position: "absolute",
      },
      thirdrowbox: {
        border: "1px solid black",
        marginLeft: 5,
        marginRight: 280,
        marginTop: 5,
        marginBottom: 10,
      },
      GD: {
        marginLeft: 380,
        fontSize: 14,
      },
      TA: {
        fontSize: 12,
        marginBottom: 10,
      },
      PP: {
        fontSize: 12,
        marginTop: 5,
        marginLeft: 380,
        marginBottom: 10,
      },
      signature: {
        fontSize: 12,
        marginTop: 20,
        marginLeft: 380,
        marginBottom: 10,
      },

      pdfContent: {
        marginBottom: 10,
      },

      table: {
        marginTop: 10,
        marginBottom: 10,
        fontSize: 12,
      },
      tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "black",
        paddingBottom: 5,
        marginBottom: 5,
        fontSize: 9,
      },
      tableCell: {
        flex: 1,
        padding: 5,
      },
      tableCel: {
        flex: 0.4,
        padding: 2,
      },
      tableCell1: {
        flex: 2,
        padding: 3,
      },
      tableHeaderCell: {
        fontWeight: "bold",
      },
      logo: {
        marginRight: 442,
        position: "absolute",
      },
      mainview: {
        marginLeft: 15,
        marginRight: 15,
      },
    });
    let totalCount = 0;
    const MyDocument = (
      <Document>
        {filteredData.map((item) => {
          if (item.Entries) {
            const numPages = Math.ceil(item.Entries.length / itemsPerPage);

            return Array.from({ length: numPages }).map((_, pageIndex) => {
              const startIndex = pageIndex * itemsPerPage;
              const endIndex = startIndex + itemsPerPage;
              const itemsToRender = item.Entries.slice(startIndex, endIndex);

              const isLastPage = pageIndex === numPages - 1;
              return (
                <Page style={styles.page}>
                  <View style={styles.mainview}>
                    <View>
                      <View style={styles.main}>
                        <View style={styles.logo}>
                          <Image
                            src={image2}
                            style={{
                              width: 130,
                              height: 60,
                              marginLeft: 12,
                              marginBottom: 2,
                            }} // Adjust the width and height as needed
                          />
                        </View>
                        <Text style={styles.pdfhead2}>
                          PINNACLE CIVIL SERVICES
                        </Text>
                        <Text style={styles.pdfhead2}>SALES RETURN</Text>
                        <Text style={styles.pdfhead2}>
                          1st Floor, 1032A/1, MM Tower, New Railway Road,
                        </Text>
                        <Text style={styles.pdfhead2}>
                          Gurugram, Haryana 122001
                        </Text>
                        <Text style={styles.pdfhead2}>
                          GST: 06AGNPD7273M1ZX , PAN: AGNPD7273M
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <View style={styles.column}>
                          <View style={styles.main2}>
                            <View style={styles.details}>
                              <Text style={styles.pdfdetails}>
                                Party Details
                              </Text>
                            </View>
                            <View style={styles.address}>
                              {matchingObject && (
                                <Text style={styles.pdfaddress}>
                                  {matchingObject.dname}:{" "}
                                  {matchingObject.shippingaddress}
                                </Text>
                              )}
                            </View>
                          </View>
                        </View>
                        <View style={styles.column}>
                          <View style={styles.main}>
                            <Text style={styles.second}>
                              GRN Number: {item.OrderSeq}
                            </Text>
                            <Text style={styles.second}>
                              Recieving Date: {item.Date}
                            </Text>
                            <Text style={styles.second}>
                              Payment Mode: {item.modeofpayment}
                            </Text>
                            <Text style={styles.second}>
                              Dispatch Through: {item.dispatchthrough}
                            </Text>
                            <Text style={styles.second}>
                              Destination: {item.destination}{" "}
                            </Text>
                            <Text style={styles.second}>
                              Terms of Delivery: {item.termofdelivery}
                            </Text>
                          </View>
                        </View>
                      </View>{" "}
                    </View>
                    <View style={styles.secondrow}>
                      <View style={styles.table}>
                        <View style={[styles.tableRow, styles.tableHeaderCell]}>
                          <View style={styles.tableCell}>
                            <Text>SN</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Particulars </Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>HSN/SAC Code</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Return Quantity</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Discount %</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>MRP</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Amount</Text>
                          </View>
                        </View>

                        {itemsToRender.map((updatedItem, updatedIndex) => {
                          totalCount++;
                          return (
                            <View key={updatedIndex} style={styles.tableRow}>
                              <View style={styles.tableCel}>
                                <Text>{totalCount}</Text>
                              </View>
                              <View style={styles.tableCell1}>
                                <Text>
                                  {updatedItem.Title} : {updatedItem.Medium} :
                                  {updatedItem.Edition}
                                </Text>
                              </View>
                              <View style={styles.tableCell}>
                                <Text>{updatedItem.HSNCode}</Text>
                              </View>
                              <View style={styles.tableCell}>
                                <Text>{updatedItem.Return_Quantity}</Text>
                              </View>
                              <View style={styles.tableCell}>
                                <Text>{updatedItem.discount}</Text>
                              </View>
                              <View style={styles.tableCell}>
                                <Text>{updatedItem.mrp}</Text>
                              </View>
                              <View style={styles.tableCell}>
                                <Text>
                                  {(
                                    updatedItem.Return_Quantity *
                                    (updatedItem.mrp -
                                      (updatedItem.mrp * updatedItem.discount) /
                                        100)
                                  ).toFixed(2)}
                                </Text>
                              </View>
                            </View>
                          );
                        })}
                      </View>
                    </View>

                    {isLastPage && (
                      <View>
                        <View style={styles.thirdrow}>
                          <Text style={styles.thirdrowquantity}>
                            Total Return Quantity: {sum}
                          </Text>

                          <Text style={styles.gst}>GST: Nil</Text>
                          <View style={styles.thirdrowbox}>
                            <Text style={styles.second2}>
                              Warranty related Terms and Conditions
                            </Text>
                            <Text style={styles.second2}>
                              Books purchase are returnable
                            </Text>
                          </View>

                          <Text style={styles.GD}>
                            GrandTotal:{total.toFixed(2)}{" "}
                          </Text>
                          <Text style={styles.TA}>
                            Total Amount ((INR - In Words)):{totalInWords}
                          </Text>
                        </View>

                        <View style={styles.forthrow}>
                          <Text style={styles.PP}>
                            {" "}
                            For Pinnacle Civil Services{" "}
                          </Text>
                        
                          <Text style={styles.signature}>
                            {" "}
                            Authorized Signatory{" "}
                          </Text>
                        </View>
                      </View>
                    )}
                  </View>
                </Page>
              );
            });
          }
        })}
      </Document>
    );
    return MyDocument;
  };

  const handleViewPDF = (rowData) => {
    const pdfWindow = window.open("", "_blank");

    if (pdfWindow) {
      pdfWindow.document.write(
        "<html><body><div id='pdf-root'></div></body></html>"
      );
      pdfWindow.document.close();

      const rootElement = pdfWindow.document.getElementById("pdf-root");

      if (rootElement) {
        ReactDOM.createRoot(rootElement).render(
          <PDFViewer width="100%" height="100%">
            {generatePDF(rowData)}
          </PDFViewer>
        );
      }
    }
  };

  const totalQuantity = filteredData.reduce(
    (sum, item) => sum + parseFloat(item.totalquantity || 0),
    0
  );

  return (
    <main className="manage-credit-note">
      <div className="manage-credit-note__content">
        <header className="manage-credit-note__header">
          <div>
            <p className="manage-credit-note__eyebrow">Returns &amp; adjustments</p>
            <h1>Manage credit notes</h1>
            <p className="manage-credit-note__subtitle">
              Review return GRNs and open or download their credit note challans.
            </p>
          </div>
          <span className="manage-credit-note__header-badge">
            {filteredData.length.toLocaleString()} return GRNs
          </span>
        </header>

        <section className="manage-credit-note__stats" aria-label="Credit note summary">
          <article className="manage-credit-note__stat-card">
            <span className="manage-credit-note__stat-label">Return GRNs</span>
            <strong>{filteredData.length.toLocaleString()}</strong>
            <span className="manage-credit-note__stat-note">Matching the current filters</span>
          </article>
          <article className="manage-credit-note__stat-card manage-credit-note__stat-card--accent">
            <span className="manage-credit-note__stat-label">Total return quantity</span>
            <strong>{Number(totalQuantity || 0).toLocaleString()}</strong>
            <span className="manage-credit-note__stat-note">Across matching return GRNs</span>
          </article>
          <article className="manage-credit-note__stat-card">
            <span className="manage-credit-note__stat-label">Current page</span>
            <strong>{currentItems.length.toLocaleString()}</strong>
            <span className="manage-credit-note__stat-note">Rows shown on this page</span>
          </article>
        </section>

        <section className="manage-credit-note__filters" aria-label="Filter credit notes">
          <div className="manage-credit-note__filters-heading">
            <div>
              <h2>Filter return GRNs</h2>
              <p>Choose a distributor or narrow results by date.</p>
            </div>
            <CSVLink
              headers={csvHeaders}
              data={csvData}
              filename={"Managereturn_" + new Date().toISOString().split("T")[0] + ".csv"}
              className="manage-credit-note__export"
            >
              <span aria-hidden="true">↓</span>
              Export CSV
            </CSVLink>
          </div>

          <div className="manage-credit-note__filter-grid">
            <div className="manage-credit-note__field manage-credit-note__field--wide">
              <label htmlFor="credit-note-distributor">Distributor</label>
              <select
                id="credit-note-distributor"
                value={selectedDistributor}
                onChange={(e) => {
                  setSelectedDistributor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                {distributorOptions.map((dist, idx) => (
                  <option key={idx} value={dist}>{dist}</option>
                ))}
              </select>
            </div>

            <div className="manage-credit-note__field">
              <label htmlFor="credit-note-start-date">Start date</label>
              <input
                id="credit-note-start-date"
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>

            <div className="manage-credit-note__field">
              <label htmlFor="credit-note-end-date">End date</label>
              <input
                id="credit-note-end-date"
                type="date"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          {(startDate || endDate) && (
            <p className="manage-credit-note__date-range">
              Date range active
              {startDate ? <strong> from {startDate}</strong> : null}
              {endDate ? <strong> through {endDate}</strong> : null}
            </p>
          )}
        </section>

        {selectedPDF ? (
          <section className="manage-credit-note__pdf-preview" aria-label="Credit note preview">
            <div className="manage-credit-note__table-heading">
              <div>
                <h2>Credit note preview</h2>
                <p>Use the document controls to review the generated challan.</p>
              </div>
            </div>
            <PDFViewer width="100%" height="500px">
              {selectedPDF}
            </PDFViewer>
          </section>
        ) : null}

        <section className="manage-credit-note__table-panel" aria-label="Return GRN list">
          <div className="manage-credit-note__table-heading">
            <div>
              <h2>Return GRN register</h2>
              <p>Open the challan in a new tab or download a copy.</p>
            </div>
            <span className="manage-credit-note__record-count">
              {filteredData.length.toLocaleString()} records
            </span>
          </div>

          <div className="manage-credit-note__table-wrap">
            <Table hover className="manage-credit-note__table">
              <thead>
                <tr>
                  <th scope="col">Party name</th>
                  <th scope="col">Return GRN no.</th>
                  <th scope="col">SKUs</th>
                  <th scope="col">Total quantity</th>
                  <th scope="col">Total value</th>
                  <th scope="col">Date</th>
                  <th scope="col">Challan</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td className="manage-credit-note__empty" colSpan={7}>
                      <span className="manage-credit-note__empty-icon" aria-hidden="true">⌕</span>
                      <strong>No credit notes found</strong>
                      <span>Try adjusting the distributor or date filters.</span>
                    </td>
                  </tr>
                ) : (
                  currentItems.map((row, index) => (
                    <tr key={row.OrderSeq || index}>
                      <td className="manage-credit-note__party-cell">{row.Distributor}</td>
                      <td className="manage-credit-note__grn-cell">{row.OrderSeq}</td>
                      <td><span className="manage-credit-note__sku-count">{row.Entries.length}</span></td>
                      <td>{row.totalquantity}</td>
                      <td className="manage-credit-note__amount-cell">{row.totalAmountValue}</td>
                      <td>{formatDate(row.Date)}</td>
                      <td>
                        <div className="manage-credit-note__row-actions">
                          <button
                            type="button"
                            className="manage-credit-note__view-button"
                            onClick={() => handleViewPDF(row)}
                          >
                            View PDF
                          </button>
                          <PDFDownloadLink
                            document={generatePDF(row)}
                            fileName="Challan.pdf"
                            className="manage-credit-note__download-button"
                            aria-label={"Download challan for GRN " + row.OrderSeq}
                          >
                            {({ loading }) => loading ? "Preparing…" : "Download"}
                          </PDFDownloadLink>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          <footer className="manage-credit-note__table-footer">
            <p>
              Showing{" "}
              <strong>
                {filteredData.length === 0 ? 0 : indexOfFirstItem + 1}
                {"–"}
                {Math.min(indexOfLastItem, filteredData.length)}
              </strong>
              {" "}of <strong>{filteredData.length}</strong> return GRNs
            </p>
            <div className="manage-credit-note__pagination" aria-label="Pagination">
              <button
                type="button"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                aria-label="Go to previous page"
              >
                ← Previous
              </button>
              <span>Page <strong>{currentPage}</strong> of <strong>{Math.max(totalPages, 1)}</strong></span>
              <button
                type="button"
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage >= Math.max(totalPages, 1)}
                aria-label="Go to next page"
              >
                Next →
              </button>
            </div>
          </footer>
        </section>
      </div>
    </main>
  );
}

export default ManageCreditNote;
